const inicialState = {
  showModal: false,
  certificadosSelecionados: [],
  listaExibido: 0,
  listaPendentes: [],
  totalPendentes: 0,
  pagina: 1
};

export default inicialState;



// WEBPACK FOOTER //
// ./src/app/common/certificacao/certificacao.state.js